import { appDependencies } from "../AppDependencies";
import { IRequestVersionInfo } from "./IRequestVersionInfo";
import { IVersionInfo } from "./IVersionInfo";

export class VersionService implements IRequestVersionInfo {
    requestVersionInfo(): Promise<IVersionInfo> {
        return appDependencies.IVersionInfoRepository.getVersionInfo();
    }
}
